module.exports = __webpack_public_path__ + "static/img/title.22fa417.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/news2/title.png
// module id = 0yxp
// module chunks = 7